import React, { useEffect } from "react";
import AppBody from "../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
   trainingAttendancesDetails,
} from "../../actions/learning_provider/training_syllabus_action";
const TrainingAttendance = () => {
  const state = useSelector((state) => state.trainingSyllabusReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
   
  useEffect(() => {
    dispatch(trainingAttendancesDetails({ id: atob(id) }));
  }, []);
  
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <a onClick={() => navigate(-1)} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </a>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Training Attendance
              </h4>          
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>User Name</th>
                      <th>Topic Name</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Rating</th>                   
                    </tr>
                  </thead>
                  <tbody>
                    {state.attendances &&
                      state.attendances.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.first_name + " " + li.last_name}</td>
                          <td>{li.session_topic}</td>
                          <td>{li.start_time ? li.start_time : "-"}</td>
                          <td>{li.end_time ? li.end_time : "-"}</td>
                          <td>{li.rating ? li.rating : "-"}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TrainingAttendance;
